import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from '../../Style/MoaStyled';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import { Typography, GuideBox } from '../..';
var getSeverityColor = function (variant, severity) {
    if (variant === 'filled')
        return '#fff';
    switch (severity) {
        case 'success': return '#2e7d32';
        case 'error': return '#D32F2F';
        case 'warning': return '#ed6c02';
        case 'info': return '#0288d1';
        default: return '#2e7d32';
    }
};
var StyledComponent = styled(function (props) {
    var id = props.id, children = props.children, variant = props.variant, severity = props.severity, title = props.title, rest = __rest(props, ["id", "children", "variant", "severity", "title"]);
    return (_jsx(Stack, { sx: { width: '100%' }, children: _jsx(Alert, __assign({ id: id, variant: variant, severity: severity, sx: {
                color: getSeverityColor(variant, severity),
            } }, rest, { children: _jsxs(GuideBox, { spacing: 1.5, paddingBottom: 0.7, children: [_jsx(GuideBox, { height: '1.375rem', verCenter: true, children: _jsx(Typography, { variant: 'h1', size: "medium", color: getSeverityColor(variant, severity), children: title }) }), _jsx(GuideBox, { spacing: 2, children: children })] }) })) }));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
